// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"107":"general-themes-tr","402":"general-themes-ru","496":"general-themes-en"}[chunkId] || chunkId) + ".ru." + {"15":"7560a06fcbf4e5ea5670","107":"57018c6ba03b8e182cf5","402":"93f9c08d7e782660c5e2","496":"7e9252dc5e70fbe67827","540":"5c9ab3d7c0607e236bfe","615":"06ff914f7025dd0708fc"}[chunkId] + ".js";
};